//#region react import
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
//#endregion

//#region functions import
import { downloadPdfFile, isPdfFileAvailable } from "../../Helper/FileHelper.js";
import { getTranslations } from "../../Helper/TranslationController.js";
//#endregion

//#region constants import
import { ICON_PDF } from "../../Constants/IconConstants.js";
import { TRANSLATIONS } from "../../Constants/Translations.js";
//#endregion

//#region style import
import { getLogValue } from "../Documentation/Documentation.constants.js";
import "./PatchNotesTitle.style.scss";
//#endregion

/**
 * component designed to be rendered in PatchNotesModal
 */

const PatchNotesTitle = ({ mainTitle, mainSummary, docTranslationKey, docFilePath }) => {
  //#region redux store
  const translations = useSelector((state) => state.translationSlice.translations);
  const language = useSelector((state) => state.translationSlice.language);
  const machines = useSelector((state) => state.machineSlice.machines);
  const activeCenterId = useSelector((state) => state.connexionSlice.trainer?.activeCenter.id);
  //#endregion

  //#region state
  const [filename, setFilename] = useState(null);
  //#endregion

  //#region others use...
  const dispatch = useDispatch();
  //#endregion

  //#region useEffect
  useEffect(() => {
    const checkFileExist = async () => {
      if (await isPdfFileAvailable(docFilePath, language)) {
        setFilename(getTranslations(docTranslationKey, translations));
      } else {
        setFilename(null);
      }
    };

    checkFileExist();
  }, [language, translations, docTranslationKey, docFilePath]);
  //#endregion
  return (
    <div className="patch-notes-title">
      <h1>{mainTitle}</h1>
      <span>{mainSummary}</span>
      {filename && (
        <div className="patch-notes-title-file">
          <div
            className="patch-notes-title-link"
            onClick={() =>
              downloadPdfFile(
                docFilePath,
                language,
                filename,
                getTranslations(TRANSLATIONS.NOTIFICATION_FILE_DOWNLOADED, translations),
                dispatch,
                getLogValue(filename, machines),
                activeCenterId
              )
            }
          >
            <i className={ICON_PDF} />
            <span>{filename}</span>
          </div>
        </div>
      )}
    </div>
  );
};
export default PatchNotesTitle;
